export default "__VITE_ASSET__DH_NX3a___"